import { Form, Formik } from 'formik';
import InputPassword from '@/components/ui/inputFormik/input-password';
import { changePasswordValidation } from '@/utils/validation/auth';
import { resetNewPassword, resetNewPasswordByMobile } from '@/services/auth';
import { toast } from 'sonner';
import { useTurnstile } from 'react-turnstile';
import TurnstileRecaptcha from '@/components/turnstile/TurnstileRecaptcha';

const ResetPassword = ({ setAuth, t, verifyOtpForValue }) => {
  const turnstile = useTurnstile();
  const handleSubmit = async (
    { password, confirmPassword, recaptchaToken },
    { setSubmitting, setFieldValue }
  ) => {
    // email
    if (!!verifyOtpForValue?.email) {
      const res = await resetNewPassword({
        email: verifyOtpForValue?.email,
        newPassword: password,
        confirmPassword: confirmPassword,
        resetToken: verifyOtpForValue?.otp,
        recaptchaToken,
      });

      if (!res?.data || res?.error?.error?.message) {
        turnstile.reset();
        setFieldValue('recaptchaToken', '');
        setAuth('otp');
        toast.error(t(res?.error?.error?.message.replaceAll('.', '')));
      } else {
        toast.success(t('Password changed successfully'));
        setAuth(false);
      }
    } else {
      // mobile
      const res = await resetNewPasswordByMobile(
        verifyOtpForValue?.mobileNumber,
        password,
        recaptchaToken
      );

      if (!res?.data || res?.error?.error?.message) {
        turnstile.reset();
        setFieldValue('recaptchaToken', '');
        setAuth('otp');
        toast.error(t(res?.error?.error?.message.replaceAll('.', '')));
      } else {
        toast.success(t('Password changed successfully'));
        setAuth(false);
      }
    }

    setSubmitting(false);
  };

  return (
    <>
      <Formik
        onSubmit={handleSubmit}
        validationSchema={changePasswordValidation(t)}
        initialValues={{
          password: '',
          confirmPassword: '',
          recaptchaToken: '',
        }}
      >
        {({ isSubmitting, setFieldValue }) => (
          <Form className='flex flex-col gap-2 px-2 py-4 max-sm:pt-3.5 max-sm:pb-1 lg:gap-4 lg:px-10'>
            <InputPassword
              name='password'
              id='password'
              title={t('Password')}
              labelClassName='max-sm:text-xs'
            />
            <InputPassword
              name='confirmPassword'
              id='confirmPassword'
              title={t('Confirm Password')}
              labelClassName='max-sm:text-xs'
            />

            <TurnstileRecaptcha
              action='reset-password'
              className='flex items-center justify-center p-2'
              onVerify={(value) => {
                setFieldValue('recaptchaToken', value);
              }}
            />
            <button
              type='submit'
              className='flex h-10 w-full cursor-pointer items-center justify-center gap-3 rounded-lg bg-red-600 py-1 font-bold text-white hover:bg-red-600/70 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-red-600 max-lg:text-sm max-sm:h-9 lg:py-1.5'
              disabled={isSubmitting}
            >
              {isSubmitting && (
                <span className='border-primary-500 size-4 animate-spin rounded-full border-t border-r py-1 max-lg:size-2' />
              )}
              {t('Change Password')}
            </button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ResetPassword;
